var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarring = function SvgWarring(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3971_31092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.98003e-07C3.35786 -6.41136e-08 6.41134e-08 3.35786 -2.98004e-07 7.5C-6.60121e-07 11.6421 3.35786 15 7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35787 11.6421 6.6012e-07 7.5 2.98003e-07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49994 11.25C7.08744 11.25 6.74994 10.9125 6.74994 10.5L6.74994 6C6.74994 5.5875 7.08744 5.25 7.49994 5.25C7.91244 5.25 8.24994 5.5875 8.24994 6L8.24994 10.5C8.24994 10.9125 7.91244 11.25 7.49994 11.25Z",
    fill: "#0552BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49994 3C7.08573 3 6.74994 3.33579 6.74994 3.75C6.74994 4.16421 7.08573 4.5 7.49994 4.5C7.91415 4.5 8.24994 4.16421 8.24994 3.75C8.24994 3.33579 7.91415 3 7.49994 3Z",
    fill: "#0552BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3971_31092"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 15,
    height: 15,
    rx: 7.5,
    transform: "rotate(-180 15 15)",
    fill: "white"
  })))));
};
export default SvgWarring;